export const Loading = ({label}: {label?: string}) => (
    <div>
        <div className="loading-spinner">
            <div className="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className="spinnerText">{label ?? 'Loading'}</div>
        </div>
    </div>
);